import styled from "styled-components";

export const SubtitleWrapper = styled.div`
  margin-bottom: 3px;
`;

export const SubtitleText = styled.span`
  font-weight: bold;
  font-size: 0.9rem;
  margin: 0;
  margin-left: 20px;
`;

export const DescriptionText = styled.span`
  font-weight: normal;
  font-size: 0.7rem;
  margin: 0;
`;
